<template>
  <div>
    <!-- 職種設定 -->
    <job-category-setting
      :job-category-settings="jobCategorySettings"
      :comment-highlights="getAnyCommentHighlights(targetIdMap.categorySetting.prefix)"
      :highlight-mode="highlightMode"
      v-on="$listeners"
    />
    <!-- マッチング設定 -->
    <job-matching-setting
      v-if="matching"
      :matching="matching"
      :comment-highlights="getAnyCommentHighlights(targetIdMap.matching.prefix)"
      :highlight-mode="highlightMode"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import JobCategorySetting from '@/components/molecules/JobCategorySetting'
import JobMatchingSetting from '@/components/molecules/JobMatchingSetting'

export default {
  components: {
    JobCategorySetting,
    JobMatchingSetting
  },
  mixins: [jobPreviewCommon],
  props: {
    jobCategorySettings: {
      type: Object,
      required: true
    },
    matching: {
      type: Object,
      default: null
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      default: false
    }
  }
}
</script>
